import { render } from "./GridMeniuCustom.vue?vue&type=template&id=c0870248&scoped=true&ts=true"
import script from "./GridMeniuCustom.vue?vue&type=script&lang=ts"
export * from "./GridMeniuCustom.vue?vue&type=script&lang=ts"

import "./GridMeniuCustom.vue?vue&type=style&index=0&id=c0870248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0870248"]])

export default __exports__